import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeFour/treasure_banner.png'
import _imports_1 from '@/assets/themeFour/treasure_top.png'
import _imports_2 from '@/assets/themeThree/copy-icon.png'
import _imports_3 from '@/assets/themeFour/treasure_line_dot.png'
import _imports_4 from '@/assets/themeFour/treasure_corner.png'


const _hoisted_1 = { class: "bauContainer" }
const _hoisted_2 = {
  class: "banner",
  style: {"position":"relative","margin-top":"-50px"}
}
const _hoisted_3 = {
  class: "svgBox",
  viewBox: "0 0 400 100"
}
const _hoisted_4 = {
  style: {"font-size":"22px","font-weight":"900","font-family":"sans-serif","filter":"url(#shadow)"},
  fill: "url(#goldGradient)"
}
const _hoisted_5 = {
  href: "#curve",
  startOffset: "50%",
  "text-anchor": "middle"
}
const _hoisted_6 = { style: {"position":"relative"} }
const _hoisted_7 = { class: "borderContainer" }
const _hoisted_8 = { class: "menuLinkCont" }
const _hoisted_9 = { class: "menuLinkWrapper" }
const _hoisted_10 = { class: "mediaListMain" }
const _hoisted_11 = { class: "mediaListScroll" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "linkCopy" }
const _hoisted_14 = { class: "menueLinkTxt" }
const _hoisted_15 = { style: {"color":"rgb(13, 176, 174)"} }
const _hoisted_16 = { style: {} }
const _hoisted_17 = { style: {"color":"#f5a130"} }
const _hoisted_18 = { style: {"color":"#ffff"} }
const _hoisted_19 = { style: {"color":"#fff"} }
const _hoisted_20 = { class: "recordsCard" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "arrow"
}
const _hoisted_23 = { class: "promo" }
const _hoisted_24 = { class: "conditionCheckContainer" }
const _hoisted_25 = { style: {"padding":"0.25rem 0"} }
const _hoisted_26 = { style: {"color":"#fff","font-weight":"700"} }
const _hoisted_27 = { class: "conditionCheckContainer" }
const _hoisted_28 = { style: {"color":"#fc974c","font-weight":"600"} }
const _hoisted_29 = { class: "conditionCheckContainer" }
const _hoisted_30 = { style: {"color":"#fc974c","font-weight":"700"} }
const _hoisted_31 = {
  class: "conditionCheckContainer",
  style: {"border":"none"}
}
const _hoisted_32 = { style: {"color":"#fc974c","font-weight":"600"} }
const _hoisted_33 = { class: "rulesCard" }
const _hoisted_34 = { class: "bottom_text" }
const _hoisted_35 = { class: "bottom_text_sub" }
const _hoisted_36 = { class: "title" }

import { computed, ref } from "vue";
import RewardBox from "./components/rewardBox.vue";
import {
  toZigZagWithFlags,
  toZigZagWithFlagsAdvance,
} from "@/utils/commonFunction";
import CustomHeader from "../components/common/customHeader.vue";
import { MEDIA_LIST, TreasureData } from "@/view/bauDoTesouro/supportScript";
import { copyValue } from "@/view/bauDoTesouro/supportScript";
import StatusPopup from "@/components/common/statusPopup.vue";
import treasureBorder from "@/assets/themeFour/treasure_border.png";
import treasureHolder from "@/assets/themeFour/treasure_holder.png";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'bauDoTesouroView',
  props: {
    dataSet: {}
  },
  emits: ["goToShare", "goToUserDetails"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()
const mediaList = ref(MEDIA_LIST);
const statusRef = ref();
const props = __props;

const emits = __emit;
const zigzagReordered = computed<any>(() => {
  return props.dataSet.activityConfig?.reward_conf;
});

const goToShare = async () => {
  emits("goToShare");
};
const goToUserDetails = async () => {
  emits("goToUserDetails");
};
const handleCopyValue = () => {
  copyValue(props.dataSet.activityConfig?.link, () => {
    statusRef.value?.open();
  });
};
const navToBack = () => {
  localStorage.setItem('footerPopupOpen', '0')
  router.go(-1)

}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bauDoTesouro.treasure'),
      "is-popup-close-back-icon": true,
      onClosePopup: navToBack
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                  _cache[2] || (_cache[2] = _createElementVNode("defs", null, [
                    _createElementVNode("path", {
                      id: "curve",
                      d: "M 20,80 Q 200,20 380,80",
                      fill: "none"
                    }),
                    _createElementVNode("linearGradient", {
                      id: "goldGradient",
                      x1: "0%",
                      y1: "0%",
                      x2: "0%",
                      y2: "100%"
                    }, [
                      _createElementVNode("stop", {
                        offset: "0%",
                        style: {"stop-color":"#ffe395","stop-opacity":"1"}
                      }),
                      _createElementVNode("stop", {
                        offset: "40%",
                        style: {"stop-color":"#d9a142","stop-opacity":"1"}
                      }),
                      _createElementVNode("stop", {
                        offset: "60%",
                        style: {"stop-color":"#b87e2e","stop-opacity":"1"}
                      }),
                      _createElementVNode("stop", {
                        offset: "100%",
                        style: {"stop-color":"#f5d482","stop-opacity":"1"}
                      })
                    ]),
                    _createElementVNode("filter", {
                      id: "shadow",
                      x: "-20%",
                      y: "-20%",
                      width: "140%",
                      height: "140%"
                    }, [
                      _createElementVNode("feGaussianBlur", {
                        in: "SourceAlpha",
                        stdDeviation: "1"
                      }),
                      _createElementVNode("feOffset", {
                        dx: "1",
                        dy: "1",
                        result: "offsetblur"
                      }),
                      _createElementVNode("feComponentTransfer", null, [
                        _createElementVNode("feFuncA", {
                          type: "linear",
                          slope: "0.7"
                        })
                      ]),
                      _createElementVNode("feMerge", null, [
                        _createElementVNode("feMergeNode"),
                        _createElementVNode("feMergeNode", { in: "SourceGraphic" })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("text", _hoisted_4, [
                    _createElementVNode("textPath", _hoisted_5, _toDisplayString(_ctx.$t('treasure.inviteFriends')), 1)
                  ])
                ])),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "treasure_chest" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: ""
                  })
                ], -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "contentHeadTitle",
          style: _normalizeStyle([{"top":"-1%"}, { backgroundImage: `url(${_unref(treasureBorder)})` }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('treasure.quickShare')), 1)
        ], 4),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_row, { class: "secContainer" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "mediaList",
                              onClick: goToShare,
                              style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}
                            }, [
                              _createElementVNode("img", {
                                src: item.icon,
                                style: {"height":"50.75px","width":"50.75px"},
                                class: "",
                                alt: ""
                              }, null, 8, _hoisted_12)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.$t("common.myLink")) + " ", 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dataSet.activityConfig?.link), 1)
                        ]),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCopyValue()))
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCopyValue()))
                        })
                      ]),
                      _createElementVNode("div", {
                        onClick: goToUserDetails,
                        class: "go_to_user_button"
                      }, [
                        _createVNode(_component_van_row, { style: {"padding":"0px 10px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, {
                              span: "15",
                              class: "myReport"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("bauDoTesouro.myReports")), 1),
                                _createElementVNode("p", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(_ctx.dataSet.activityConfig?.valid_user_count) + " ", 1),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("common.pepole")) + _toDisplayString(" (" + _ctx.$t("common.valid")), 1),
                                  _createTextVNode(" " + _toDisplayString(`
                        ${_ctx.dataSet.activityConfig?.valid_user_count}`) + " ", 1),
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("common.pepole") + ")"), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_van_col, {
                              span: "9",
                              class: "details_btn"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("treasure.details") + " >"), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "contentHeadTitle",
                      style: _normalizeStyle([{"bottom":"86.5%","left":"-6%","width":"112%"}, { backgroundImage: `url(${_unref(treasureBorder)})` }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('treasure.refReward')), 1)
                    ], 4),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_van_row, { class: "cardRow" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zigzagReordered.value, (value, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "cardCol",
                              style: {"width":"25%"}
                            }, [
                              (!value.isNullObject)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(RewardBox, {
                                      peopleCount: value.valid_count,
                                      reward: value.reward,
                                      side: value.side,
                                      down: value.turnDown,
                                      isInCorner: value.isInCorner,
                                      received: value?.received,
                                      isLast: value.isLast
                                    }, null, 8, ["peopleCount", "reward", "side", "down", "isInCorner", "received", "isLast"]),
                                    (Number(index) % 4 !== 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_van_row, { style: {"padding":"10px","color":"#fff"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_van_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("mystery.effectivePromotion")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_row, { style: {"padding":"0px 10px 10px 10px","color":"#ffffff99"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_van_col, { span: 18 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("mystery.requiredDeposit")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: 6,
                    class: "arrowImgRight"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_28, _toDisplayString("≥") + _toDisplayString(parseFloat(_ctx.dataSet.activityConfig?.recharge_require)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_van_col, { span: 18 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("mystery.requiredTurnove")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: 6,
                    style: {"display":"flex","justify-content":"flex-end"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_30, _toDisplayString("≥") + _toDisplayString(parseFloat(_ctx.dataSet.activityConfig?.turnover_require)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_van_col, { span: 18 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("report.ipLimit")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: 6,
                    style: {"display":"flex","justify-content":"flex-end"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.dataSet.activityConfig?.ip_limit), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: _imports_3,
                  style: {"width":"10%"},
                  alt: ""
                }, null, -1)),
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("tresure.rule")), 1),
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: _imports_3,
                  style: {"width":"10%","transform":"scaleX(-1)"},
                  alt: ""
                }, null, -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.descriptionHtml, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "line_text",
                  key: index
                }, _toDisplayString(item), 1))
              }), 128))
            ])
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("img", {
          src: _imports_4,
          style: {"width":"10%","position":"absolute","bottom":"-9px","left":"10px","transform":"scaleX(-1)"}
        }, null, -1)),
        _cache[8] || (_cache[8] = _createElementVNode("img", {
          src: _imports_4,
          style: {"width":"10%","position":"absolute","bottom":"-9px","right":"10px"}
        }, null, -1)),
        _createVNode(StatusPopup, {
          ref_key: "statusRef",
          ref: statusRef,
          content: _ctx.$t('common.successfullyCopied'),
          isShowSuccess: true
        }, null, 8, ["content"])
      ])
    ])
  ], 64))
}
}

})